/**
 * Rechargement « nucléaire » : purge tous les caches du navigateur, désenregistre
 * tous les service workers, puis force un rechargement complet. Utilisé au clic
 * sur « Recharger » du bandeau de nouvelle version — garantit qu'aucun asset
 * périmé ne survit (ni cache HTTP applicatif via SW, ni ancien SW actif).
 */
export async function nuclearReload(): Promise<void> {
  try {
    if ('caches' in globalThis) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch {
    /* purge best-effort : on recharge quand même */
  }

  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
    }
  } catch {
    /* désenregistrement best-effort : on recharge quand même */
  }

  // Rechargement dur : nouvelle requête HTML → nouveaux assets hashés + nouveau SW.
  location.reload();
}
